import { render, staticRenderFns } from "./HotGoods.vue?vue&type=template&id=55be63d8"
import script from "./HotGoods.vue?vue&type=script&lang=js"
export * from "./HotGoods.vue?vue&type=script&lang=js"
import style0 from "./HotGoods.vue?vue&type=style&index=0&id=55be63d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports